import { useTranslation } from 'react-i18next';

import useAiChatToolLabel from '../../hooks/useAiChatToolLabel';
import useAiChatToolStatus from '../../hooks/useAiChatToolStatus';
import AiChatToolCard from '../AiChatToolCard';

import type { ReactElement } from 'react';
import type { IAiChatToolCallOf } from '../../interfaces/IAiChatToolCall';

/** The `createWatchCompanies` tool call: insert of new Watch Tower seeds. */
function CreateWatchCompaniesToolCall({
  part,
}: IAiChatToolCallOf<'createWatchCompanies'>): ReactElement {
  const { t } = useTranslation();
  const label = useAiChatToolLabel('createWatchCompanies');
  const status = useAiChatToolStatus(part.state);

  let summary = status;
  if (part.state === 'output-available') {
    if (part.output.error) {
      summary = t('aiChat.tools.watchCompaniesCreateInvalid');
    } else {
      summary = t('aiChat.tools.watchCompaniesCreated', {
        count: part.output.created?.length || 0,
      });
    }
  }

  return <AiChatToolCard name={label} status={summary} errorText={part.errorText} />;
}

export default CreateWatchCompaniesToolCall;
